module.exports = __webpack_public_path__ + "static/scale-model-of-heritage-court-in-torrance-california-3de444f44ab1b058a03b0cdf977e8b9a.png";